import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { ThemeProvider } from "@mui/material";
import getTheme from "theme";
import { MetaMaskProvider } from "@metamask/sdk-react";

import { PageNotFound } from "pages/PageNotFound";
import { Home } from "pages/Home/Home";
import { CustomSnackbar } from "components/CustomSnackbar";
import { CustomBackdrop } from "components/CustomBackdrop";
import { GiveAwayPage } from "pages/GiveAway/GiveAwayPage";
import { ReceivePage } from "pages/Receive/ReceivePage";

function App() {
  const [darkMode, setDarkMode] = useState(true);
  return (
    <BrowserRouter>
      <MetaMaskProvider
        debug={false}
        sdkOptions={{
          dappMetadata: {
            name: "MagicPenny",
            url: window.location.href,
          },
          infuraAPIKey: process.env.REACT_APP_BLOCKCHAIN_INFURA_ID,
        }}
      >
        <ThemeProvider theme={getTheme("light")}>
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/give-away" element={<GiveAwayPage />} />
            <Route exact path="/receive" element={<ReceivePage />} />
            <Route path={"*"} exact element={<PageNotFound />} />
          </Routes>
          <CustomSnackbar />
          <CustomBackdrop />
        </ThemeProvider>
      </MetaMaskProvider>
    </BrowserRouter>
  );
}

export default App;
